import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import './Admin.css';

const Admin = () => {
    const { user } = useAuth();
    const [users, setUsers] = useState([]);
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        if (user?.role !== 'admin') {
            setError('У вас нет прав доступа к админ-панели');
            setLoading(false);
            return;
        }
        loadData();
    }, [user]);

    const loadData = async () => {
        try {
            setLoading(true);
            const [usersRes, statsRes] = await Promise.all([
                api.get('/admin/users'),
                api.get('/admin/stats/overall')
            ]);
            setUsers(usersRes.data.users);
            setStats(statsRes.data.stats);
            setError('');
        } catch (err) {
            setError(err.response?.data?.error || 'Ошибка загрузки данных');
        } finally {
            setLoading(false);
        }
    };

    const toggleUserActive = async (userId) => {
        try {
            await api.patch(`/admin/users/${userId}/toggle-active`);
            await loadData();
        } catch (err) {
            alert(err.response?.data?.error || 'Ошибка изменения статуса');
        }
    };

    const changeUserRole = async (userId, newRole) => {
        if (!window.confirm(`Изменить роль пользователя на "${newRole}"?`)) return;

        try {
            await api.patch(`/admin/users/${userId}/role`, { role: newRole });
            await loadData();
        } catch (err) {
            alert(err.response?.data?.error || 'Ошибка изменения роли');
        }
    };

    if (loading) {
        return <div className="admin-page"><div className="loading">Загрузка...</div></div>;
    }

    if (error && !stats) {
        return <div className="admin-page"><div className="error">{error}</div></div>;
    }

    return (
        <div className="admin-page">
            <h1>Админ-панель</h1>

            {stats && (
                <div className="stats-cards">
                    <div className="stat-card">
                        <h3>Всего пользователей</h3>
                        <div className="stat-value">{stats.totalUsers}</div>
                    </div>
                    <div className="stat-card">
                        <h3>Активных</h3>
                        <div className="stat-value green">{stats.activeUsers}</div>
                    </div>
                    <div className="stat-card">
                        <h3>Новых за 30 дней</h3>
                        <div className="stat-value blue">{stats.recentUsers}</div>
                    </div>
                    <div className="stat-card">
                        <h3>Записей веса</h3>
                        <div className="stat-value">{stats.totalWeightRecords}</div>
                    </div>
                    <div className="stat-card">
                        <h3>Тренировок</h3>
                        <div className="stat-value">{stats.totalWorkouts}</div>
                    </div>
                    <div className="stat-card">
                        <h3>Привычек</h3>
                        <div className="stat-value">{stats.totalBadHabits}</div>
                    </div>
                </div>
            )}

            <div className="users-section">
                <h2>Пользователи</h2>
                {error && <div className="error">{error}</div>}

                <div className="users-table-container">
                    <table className="users-table">
                        <thead>
                            <tr>
                                <th>Email</th>
                                <th>Имя</th>
                                <th>Роль</th>
                                <th>Статус</th>
                                <th>Регистрация</th>
                                <th>Действия</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map(u => (
                                <tr key={u.id} className={!u.isActive ? 'inactive' : ''}>
                                    <td>{u.email}</td>
                                    <td>{u.name || '-'}</td>
                                    <td>
                                        <select
                                            value={u.role}
                                            onChange={(e) => changeUserRole(u.id, e.target.value)}
                                            disabled={u.id === user?.id}
                                            className="role-select"
                                        >
                                            <option value="user">User</option>
                                            <option value="admin">Admin</option>
                                        </select>
                                    </td>
                                    <td>
                                        <span className={`status-badge ${u.isActive ? 'active' : 'inactive'}`}>
                                            {u.isActive ? 'Активен' : 'Заблокирован'}
                                        </span>
                                    </td>
                                    <td>{new Date(u.createdAt).toLocaleDateString('ru-RU')}</td>
                                    <td>
                                        <button
                                            onClick={() => toggleUserActive(u.id)}
                                            disabled={u.id === user?.id}
                                            className="btn-small"
                                        >
                                            {u.isActive ? 'Заблокировать' : 'Разблокировать'}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Admin;
